import { type ChangeEvent, type KeyboardEvent, useRef, useState } from 'react'

import { useSearchFilterStore } from '@/entities/map'

type Props = {
  defaultValue?: string
  onEnterKeyDown?: () => void
}

export const useKeyword = ({ defaultValue, onEnterKeyDown }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const [value, setValue] = useState(defaultValue || '')

  const filterActions = useSearchFilterStore(state => state.actions)

  const handleKeywordInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }

  const handleKeywordInputKeyDown = (
    event: KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.nativeEvent.isComposing) return

    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()

      filterActions.updateKeyword(value)
      inputRef.current?.blur()

      onEnterKeyDown?.()
    }
  }

  const handleKeywordInputReset = () => {
    setValue('')
    filterActions.updateKeyword('')
  }

  return {
    keywordInputRef: inputRef,
    value,
    handleKeywordInputChange,
    handleKeywordInputKeyDown,
    handleKeywordInputReset,
  }
}
